export const DefaultPaginationConfig = {
  current: 1,
  limit: 20,
  offset: 0,
  totalPages: 0,
};
